import { Component, OnDestroy, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { GetPushConfigs, UpdatePushConfigs } from "@edp-store/actions/notifications.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getPushConfigs } from "@edp-store/selectors/notifications.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "edp-overlay-push-configs",
    templateUrl: "./edp-overlay-push-configs.component.html",
    styleUrls: ["./edp-overlay-push-configs.component.scss"],
})
export class EdpOverlayPushConfigsComponent implements OnInit, OnDestroy {
    @Output() public closeSideBar = new EventEmitter<boolean>();

    private unsubscribe = new Subject();
    public pushConfigs: any;
    public selectedAll = false;
    public hasDD = false;
    private contract: Contract;

    public constructor(private store: Store<IAppState>) {
        this.store.dispatch(new GetPushConfigs());
        this.store.pipe(takeUntil(this.unsubscribe), select(getPushConfigs)).subscribe(configs => {
            if (!!configs) {
                this.pushConfigs = configs;
            }
        });

        this.store.pipe(takeUntil(this.unsubscribe), select(getContract)).subscribe((contract: Contract) => {
            this.contract = contract;
            if (!!contract) {
                this.hasDD = contract.HasDirectDebit;
            }
        });
    }

    public ngOnInit(): void {}

    public enableGeSession() {
        return !!this.contract.SmartNow?.HasSmartNow;
    }

    public selectOverlay(type: string): void {
        this.store.dispatch(new SelectOverlayAction(type));
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public setOption(event, category, type) {
        const option = this.pushConfigs[category].find(el => el.type === type);

        this.store.dispatch(
            new UpdatePushConfigs({
                options: [
                    {
                        optionId: option.id,
                        optionStatus: event,
                    },
                ],
            })
        );
    }

    public getOptionStatus(category, type) {
        return !!this.pushConfigs ? this.pushConfigs[category].find(el => el.type === type)?.status : false;
    }

    public setAll(event) {
        this.selectedAll = event;
        const options = [];

        Object.keys(this.pushConfigs)
            .filter(el => el !== "CHANNEL")
            .forEach(el2 => {
                this.pushConfigs[el2].forEach(option => {
                    options.push({
                        optionId: option.id,
                        optionStatus: event,
                    });
                });
            });

        this.store.dispatch(new UpdatePushConfigs({ options }));
    }
}
